var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blogs"},[_c('div',{staticClass:"blogs-cont"},[_c('div',{staticClass:"blogs-cont-item"},[_c('div',{staticClass:"blogs-cont-item-title"},[_c('strong',[_vm._v(_vm._s(_vm.list?.title || ''))])]),_c('div',{staticClass:"blogs-cont-item-text"},[_c('p',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.list?.content)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }